import { render } from "./VerifyOTPForm.vue?vue&type=template&id=bea49244&scoped=true"
import script from "./VerifyOTPForm.vue?vue&type=script&lang=js"
export * from "./VerifyOTPForm.vue?vue&type=script&lang=js"

import "./VerifyOTPForm.vue?vue&type=style&index=0&id=bea49244&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bea49244"],['__file',"src/components/LoginFlow/VerifyOTPForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bea49244"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bea49244', __exports__)) {
    api.reload('bea49244', __exports__)
  }
  
  module.hot.accept("./VerifyOTPForm.vue?vue&type=template&id=bea49244&scoped=true", () => {
    api.rerender('bea49244', render)
  })

}


export default __exports__